import React, { useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentDialogInner from "./PaymentDialog";

const STRIPE_PK_KEY = process.env.REACT_APP_STRIPE_PK_KEY;

export default function PaymentDialogWrapper({
  eventFee,
  onClose,
  onSuccess,
  context,
}) {
  const stripePromise = useMemo(() => {
    if (!STRIPE_PK_KEY) {
      return null;
    }
    
    return loadStripe(STRIPE_PK_KEY, {
      stripeAccount: context.currentClub?.stripeAccountId,
    });
  }, [context.currentClub?.stripeAccountId]);

  if (!STRIPE_PK_KEY) {
    return null;
  }

  return (
    <Elements stripe={stripePromise}>
      <PaymentDialogInner
        eventFee={eventFee}
        onClose={onClose}
        onSuccess={onSuccess}
        context={context}
      />
    </Elements>
  );
}
